import {
  PLAYER_JOIN_GAME,
  PLAYER_JOINED_GAME,
  PLAYER_READY_REQUEST,
  PLAYER_READY_FOR_GAME,
  ABLY_PLAYER_JOINED_GAME,
  ABLY_PLAYER_LEFT_GAME,
  ABLY_PLAYER_READY,
  ABLY_PLAYER_ANSWER_HAS_CHECKED,
  ABLY_PLAYER_ANSWER_HAS_SELECTED,
  PLAYER_ANSWER_REQUEST,
  PLAYER_ANSWER_SUCCESS,
  PLAYER_LEAVE_GAME,
  PLAYER_LEFT_GAME,
  PLAYER_REJOIN_GAME,
  PLAYER_SEND_GIFT_REQUEST,
  PLAYER_SEND_GIFT_SUCCESS,
  PLAYER_COINS_CHANGED,
  ABLY_PLAYER_GIFT_HAS_RECEIVED,
  TEAM_GETS_POINTS,
  PLAYER_GETS_POINTS,
  PLAYER_NOTICE_CLEARED,
  PLAYER_KICK_REQUEST,
  PLAYER_KICK_SUCCESS,
  PLAYER_KICK_FAILURE,
  ABLY_PLAYER_KICK_INIT,
  ABLY_PLAYER_KICK_VOTED,
  ABLY_PLAYER_KICKED,
  PLAYER_KICK_CANCEL,
  PLAYER_REMOTE_VIDEO_MUTED,
  PLAYER_REMOTE_VIDEO_UNMUTED,
} from '../types';
import {
  API_PLAYER_JOIN_GAME,
  API_PLAYER_READY,
  API_PLAYER_ANSWER,
  API_PLAYER_LEAVE,
  API_PLAYER_SEND_GIFT,
  API_PLAYER_KICK,
} from '../../configs/apis';
import Api from '../../utils/api';
import {forwardTo} from '../../utils';
import {handleError} from '../error';
import {fetchUserCoins} from '../user';

export function kickPlayer(params) {
  return async (dispatch) => {
    try {
      const {appId, gameId, playerId} = params;
      dispatch({type: PLAYER_KICK_REQUEST, params});
      const response = await Api.post(API_PLAYER_KICK, {}, {appId, gameId, playerId});
      return dispatch({type: PLAYER_KICK_SUCCESS, response});
    } catch (error) {
      return dispatch({type: PLAYER_KICK_FAILURE, error});
    }
  };
}

export function onPlayerJoin(params, onlinePlayers = []) {
  return async (dispatch) => {
    try {
      const {appId, gameId, type, definitionValue, redirect} = params;
      dispatch({type: PLAYER_JOIN_GAME, params});
      const response = await Api.post(
        API_PLAYER_JOIN_GAME,
        {type, definitionValue},
        {appId, gameId}
      );
      dispatch({type: PLAYER_JOINED_GAME, response, onlinePlayers});
      if (redirect) {
        forwardTo(`/game/${gameId}`);
      }
      return true;
    } catch (error) {
      return dispatch(handleError(error));
    }
  };
}

export function onPlayerLeave(params) {
  return async (dispatch) => {
    try {
      const {appId, gameId, type, team} = params;
      dispatch({type: PLAYER_LEAVE_GAME, params});
      const response = await Api.post(API_PLAYER_LEAVE, {type, team}, {appId, gameId});
      dispatch({type: PLAYER_LEFT_GAME, response});

      return forwardTo('/lobby');
    } catch (error) {
      return dispatch(handleError(error));
    }
  };
}

export function onPlayerReady(params) {
  return async (dispatch) => {
    try {
      const {appId, gameId} = params;
      dispatch({type: PLAYER_READY_REQUEST, params});
      const response = await Api.post(API_PLAYER_READY, {}, {appId, gameId});

      return dispatch({type: PLAYER_READY_FOR_GAME, response});
    } catch (error) {
      return dispatch(handleError(error));
    }
  };
}

export function onPlayerAnswer(params) {
  return async (dispatch) => {
    try {
      const {appId, gameId, answerId} = params;

      dispatch({type: PLAYER_ANSWER_REQUEST, params});

      const response = await Api.post(API_PLAYER_ANSWER, {answerId}, {appId, gameId});

      dispatch({type: PLAYER_ANSWER_SUCCESS, response});

      const coins = await fetchUserCoins();

      return dispatch({type: PLAYER_COINS_CHANGED, coins});
    } catch (error) {
      return dispatch(handleError(error));
    }
  };
}

export function onPlayerSendGift(params) {
  return async (dispatch) => {
    try {
      const {appId, gameId, gift, playerId} = params;
      dispatch({type: PLAYER_SEND_GIFT_REQUEST, params});
      const response = await Api.post(
        API_PLAYER_SEND_GIFT,
        {playerId},
        {appId, gameId, giftId: gift.id});
      return dispatch({type: PLAYER_SEND_GIFT_SUCCESS, response});
    } catch (error) {
      return dispatch(handleError(error));
    }
  };
}

export function onPlayerJoinMessage(newPlayer) {
  return {
    type: ABLY_PLAYER_JOINED_GAME,
    newPlayer,
  };
}

export function onPlayerGiftSent(gift, playerId) {
  return async (dispatch) => {
    try {
      const {receiverId, senderId} = gift;

      if ([receiverId, senderId].includes(playerId)) {
        const coins = await fetchUserCoins();

        dispatch({type: PLAYER_COINS_CHANGED, coins});
      }

      return dispatch({type: ABLY_PLAYER_GIFT_HAS_RECEIVED, gift});
    } catch (error) {
      return dispatch(handleError(error));
    }
  };
}

export function onPlayerLeft(player) {
  return {
    type: ABLY_PLAYER_LEFT_GAME,
    player,
  };
}

export function onPlayerReadyMessage(player) {
  return {
    type: ABLY_PLAYER_READY,
    player,
  };
}

export function onPlayerAnswerHasChecked(answer) {
  return {
    type: ABLY_PLAYER_ANSWER_HAS_CHECKED,
    answer,
  };
}

export function onPlayerAnswerHasSelected(answer) {
  return {
    type: ABLY_PLAYER_ANSWER_HAS_SELECTED,
    answer,
  };
}

export function onPlayerNotesClear(playerId) {
  return {
    type: PLAYER_NOTICE_CLEARED,
    playerId,
  };
}

export function onTeamGetsPoints(data) {
  return {
    type: TEAM_GETS_POINTS,
    data,
  };
}

export function onPlayerGetsPoints(data) {
  return {
    type: PLAYER_GETS_POINTS,
    data,
  };
}

export function onPlayerKickInit(data, userId) {
  return {
    type: ABLY_PLAYER_KICK_INIT,
    data,
    userId,
  };
}

export function onPlayerKickCancel() {
  return {
    type: PLAYER_KICK_CANCEL,
  };
}

export function onPlayerKickVoted(data) {
  return {
    type: ABLY_PLAYER_KICK_VOTED,
    data,
  };
}

export function onPlayerKicked(data, userId) {
  return {
    type: ABLY_PLAYER_KICKED,
    data,
    userId,
  };
}

export function onRemoteVideoMuted(data) {
  return {
    type: PLAYER_REMOTE_VIDEO_MUTED,
    data,
  };
}

export function onRemoteVideoUnmuted(data) {
  return {
    type: PLAYER_REMOTE_VIDEO_UNMUTED,
    data,
  };
}

export function onPlayerRejoined(data) {
  return {
    type: PLAYER_REJOIN_GAME,
    data,
  };
}
